@if(this.csvURL){<a class="download-link" (click)="download()">
    <img [src]="ICONS.DOWNLOAD" alt="Download"/>
</a>}
@if(!this.csvURL){<span>{{"not_available" | translate}}</span>}